$(document).ready(customProduct);
document.addEventListener("ShoptetDOMPageContentLoaded", customProduct);
document.addEventListener("ShoptetPageSortingChanged", customProduct);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", customProduct);
document.addEventListener("ShoptetDOMContentLoaded", customProduct);

function customProduct() {
  $(".product").each(function () {
    const $product = $(this);

    if ($product.find(".p-tools form").length) {
      if (!$product.find(".quantity").length) {
        $product.find(".p-tools form").prepend($quantity);
      }
    } else {
      $product.find(".p-tools a").text("Detail produktu");
    }
    const $priceSave = $product.find(".price-save");
    if ($priceSave.length) {
      if (!$product.find(".flags-default .price-save").length && !$product.find(".flags-default .flag-sale").length) {
        $product.find(".flags-default").prepend('<span class="flag flag-sale">sleva ' + $priceSave.html() + "</span>");
      }
      if (!$product.find(".prices .price-save").length) {
        $product.find(".prices").append($product.find(".flag-discount .price-save").clone());
      }
      if (!$product.find(".prices .price-standard").length) {
        $product.find(".prices").append($product.find(".flag-discount .price-standard").clone());
      }
    }

    const $ratings = $product.find(".stars-wrapper");
    if ($ratings.length) {
      if (!$product.find(".p-in-in>.stars-wrapper").length) {
        $product.find(".p-in-in").prepend($ratings);
        $ratings.append('<span class="rating-text">' + $ratings.data("micro-rating-count") + " hodnocení</span>");
      }
    }
    else {
      $product.find('.p-in-in').prepend('\
        <div class="stars-wrapper">\
  <span class="stars star-list">\
    <span class="star star-off" aria-hidden="true"></span>\
    <span class="star star-off" aria-hidden="true"></span>\
    <span class="star star-off" aria-hidden="true"></span>\
    <span class="star star-off" aria-hidden="true"></span>\
    <span class="star star-off" aria-hidden="true"></span>\
  </span>\
  <span class="rating-text">0 hodnocení</span>\
</div>');
    }

    const $starList = $product.find(".stars.star-list");
    if ($starList.length) {
      const ratingText = $starList.find(".sr-only").text().replace(",", ".");
      const ratingMatch = ratingText.match(/(\d+(?:\.\d+)?)/);
      const ratingValue = ratingMatch ? parseFloat(ratingMatch[1]) : null;

      if (ratingValue !== null) {
        const decimalPart = ratingValue % 1;
        if (decimalPart > 0) {
          const halfStarIndex = Math.floor(ratingValue) + 1;
          $starList.find(".star").eq(halfStarIndex - 1).addClass("star-half");
        }
      }
    }

    $product.find(".availability").attr("style", $product.find(".availability>span").attr("style"));
  });
}

var $quantity = `
    <span class="quantity">
        <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMax" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMin" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <label>
            <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množství" data-testid="cartAmount">
        </label>
        <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
            <span class="increase__sign">+</span>
        </button>
        <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
            <span class="decrease__sign">−</span>
        </button>
    </span>
`;

$("html").on("click", ".products .product button.add-to-cart-button", function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  var inputVal = $(this).closest(".p-tools").find("input").val();
  var inputPriceId = $(this).closest(".p-tools").find('input[name="priceId"]').attr("value");
  shoptet.cartShared.addToCart({ priceId: inputPriceId, amount: inputVal });
});
